import { RenderDetailViewProps } from 'interfaces/model.interface'

import { IDTreatments360RevenueData } from 'config/common/baseModel/ida360/IDPremiumRevenue'

import Detail from './Detail'

export const IDARevenueDetailView = ({
  model,
  data,
  setSelectedRow,
  viewData,
}: RenderDetailViewProps<Record<IDTreatments360RevenueData, string>>) => {
  if (!data) {
    return null
  }
  return (
    <Detail
      model={model}
      title='id'
      deals={data}
      handleClose={() => setSelectedRow(null)}
      viewData={viewData}
    />
  )
}
